"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobLocationType = void 0;
exports.JobLocationType = {
    INBOUND: "INBOUND",
    NON_COMPLIANCE: "NON_COMPLIANCE",
    OUTBOUND: "OUTBOUND",
    WORKSTATION: "WORKSTATION",
};
//# sourceMappingURL=job-location-type.js.map